module.exports = __webpack_public_path__ + "img/开票.a1f1d08c.png";